import {
  Theme,
  createTheme,
  generateColorScale,
} from "@fraktion/core-frontend";

export const theme: Theme = createTheme({
  tokens: {
    colors: {
      base: {
        primary: generateColorScale("#000000"),
        secondary: generateColorScale("#FFD700"),
      },
    },
    typography: {
      fontFamily: {
        sans: { value: "Inter, system-ui, sans-serif" },
      },
    },
  },
});

export const darkTheme: Theme = createTheme({
  ...theme,
  mode: "dark",
});
